import {useEffect} from "react";
import CoverageLimitDropDown from "./CoverageLimitDropDown";
import { v4 as uuidv4 } from 'uuid';


export default function PolicyCoverageList(props: any) {

    const { ratedCoverages, policyCoverages, onPolicyCoverageChange,coverageChanges } = props;

    useEffect(()=>{
    }, [policyCoverages]);

    return <>
        {
            (ratedCoverages?.distinctCoverages ?? []).map((v: any, i: any) => {
                if (!v.isVehicleCoverage) {
                    
                    //var coverageLimits = v.coverageLimits.find((x:any)=>x.name == v.coverage);

                    var currentCoverage = policyCoverages.find((m:any) => m.coverage == v.coverage);
                    var policyCoverage = {...currentCoverage};
                    var currentSelectedCoverage = coverageChanges.find((m:any)=> m.coverage == v.coverage);
                    var currentLimit = "";
  
                    if(policyCoverage != undefined){
                        currentLimit = policyCoverage.limit;
                    }

                    if(currentSelectedCoverage!= undefined){
                        currentLimit = currentSelectedCoverage.limit;
                    }

                    if(currentCoverage == undefined){
                        currentLimit = v.emptyLimit;
                    }

                    policyCoverage.emptyLimit = v.emptyLimit;
                    // var currentLimit = currentCoverage?.limit ?? "";
                    return (
                        <>
                            <CoverageLimitDropDown
                                //key={v.coverage}
                               // key={uuidv4()}
                               key={`PLCV_${(i+1)}_${currentLimit}`}
                                lookupCoverages={(ratedCoverages.coverages ?? [])}
                                coverage={v}
                                currentCoverage={policyCoverage}
                                currentLimit={currentLimit}
                                onLimitChange={onPolicyCoverageChange}
                            />
                        </>
                    )
                }
            })
        }
    </>;
}